import React from "react";
import { Box } from "rebass/styled-components";

const SelfcareMobileWrapper = ({ display = "inline", ...props }) => (
  <Box {...props} display={[display, "none", "none"]} />
);

export default SelfcareMobileWrapper;
